import React from 'react';

import { useTranslations } from '@vk-hr-tek/core/hooks';

import { SystemLinkItem } from '@app/gen/side_menu';
import { Can } from '@app/ability';

import { UserRoleEnum } from '../../../../app/types';
import {
  sidebarCustomIcons,
  sidebarIcons,
  systemLinkToNavigationItem,
} from '../helpers';
import { AbilityProvider } from '../../../../layout/AbilityProvider';

import { SidebarItem } from './SidebarItem';

interface SidebarLinkItemProps {
  item: SystemLinkItem;
  sidebarOpened: boolean;
  pathname: string;
  isSkeletonLoading: boolean;
  onMenuItemClick: (pageTitle: string) => void;
  isActive: (path: string, href: string) => boolean;
}

export const SidebarLinkItem = ({
  item,
  sidebarOpened,
  pathname,
  isSkeletonLoading,
  isActive,
  onMenuItemClick,
}: SidebarLinkItemProps) => {
  const { t } = useTranslations();

  const { resource, parentResource, role, basename, href, icon } =
    systemLinkToNavigationItem(item);
  const finalResource = parentResource ?? resource;

  const isActiveItem = isActive(pathname, href);
  const sidebarIcon = icon
    ? sidebarIcons()[item.nick]
    : sidebarCustomIcons().globe;
  const linkItemRole = role && role !== 'general' ? role : UserRoleEnum.Company;

  return (
    <AbilityProvider key={item.nick} role={role as UserRoleEnum}>
      <Can do="read" on={resource}>
        <SidebarItem
          href={href ?? ''}
          icon={sidebarIcon}
          aqaClass={`aqa_${basename}`}
          title={t(`modules.${finalResource}.${basename}.${linkItemRole}Title`)}
          sidebarOpened={sidebarOpened}
          isActive={isActiveItem}
          skeletonLoading={isSkeletonLoading}
          onClick={onMenuItemClick}
        />
      </Can>
    </AbilityProvider>
  );
};
